import dayjs from 'dayjs';

import { IFormValues } from './types';

export const DEFAULT_VALUES: IFormValues = {
  clientUUID: null,
  date: dayjs().format(),
  time: '',
  duration: '',
  hostsIds: [],
  comment: '',
};
